// src/api/adminApi.js
import { getAuthToken } from "../utils/auth";
import {
  API_BASE_URL,
  UPDATE_USER_PREFERENCES_V1_URL,
  DELETE_USER_URL,
  GET_ALL_PRODUCTS_URL,
  CREATE_USER_V1_URL,
  PRODUCT_SEARCH_URL,
} from "../config/apiConfig";

export const updateUserPreferences = async (userData) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Authentication required");
  }

  const response = await fetch(
    UPDATE_USER_PREFERENCES_V1_URL,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      
      },
      body: JSON.stringify(userData),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP ${response.status}: Update failed`);
  }

  return await response.json();
};

// NEW: Delete User API
export const deleteUser = async (customer_id) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Authentication required");
  }

  const response = await fetch(
    DELETE_USER_URL,
    {
      method: "PUT", // as per your spec
      headers: {
        "Content-Type": "application/json",
       
      },
      body: JSON.stringify({ customer_id }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP ${response.status}: Delete failed`);
  }

  return await response.json(); // or just return { success: true }
};

// Create new user
export const createUser = async (userData) => {
  const response = await fetch(CREATE_USER_V1_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || "Failed to create user"
    );
  }

  return await response.json();
};


export const fetchProducts = async (page = 1, pageSize = 50) => {
  const url = new URL(GET_ALL_PRODUCTS_URL);
  if (page) url.searchParams.set("page", page);
  if (pageSize) url.searchParams.set("page_size", pageSize);

  const response = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch products: ${response.status}`);
  }

  const data = await response.json();
  return {
    products: data.products || [],
    currentPage: data.page || 1,
    pageSize: data.page_size || 50,
    totalPages: data.total_pages || 1,
    totalRecords: data.total_records || 0,
  };
};

// Enrich product description
export const enrichProduct = async (article_id, additional_prompt = "") => {
  const response = await fetch(`${API_BASE_URL}/enrich_product`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ article_id, additional_prompt }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP ${response.status}: Enrich failed`);
  }
  return await response.json(); // returns { article_id, enriched_data: { ..., enriched_description } }
};

// Update enriched description
export const updateEnrichedProduct = async (article_id, enhanced_description) => {
  const response = await fetch(`${API_BASE_URL}/update_enrich_product`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ article_id, enhanced_description }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP ${response.status}: Update failed`);
  }
  return await response.json(); // returns updated product
};

// Update Full Product (e.g. stock, name, attributes, etc.)
export const updateProduct = async (productData) => {
  // Validate required field
  if (!productData.article_id) {
    throw new Error("article_id is required");
  }

  const response = await fetch(`${API_BASE_URL}/update_product`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(productData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || `HTTP ${response.status}: Update product failed`
    );
  }

  const result = await response.json();
  return result;
};

// adminApi.js search product
export const searchProducts = async (filters, page = 1, size = 50) => {
  const payload = {
    page,
    size,
    filters: { ...filters }, // we'll clean empty fields below
  };

  // Remove blank/empty fields (e.g. "", null, undefined)
  Object.keys(payload.filters).forEach(key => {
    const val = payload.filters[key];
    if (val === "" || val == null) {
      delete payload.filters[key];
    }
  });

  const res = await fetch(
    PRODUCT_SEARCH_URL,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload.filters), // Note: backend expects *just* filters (not page/size in body)
    }
  );

  if (!res.ok) {
    throw new Error(`Search failed: ${res.status} ${res.statusText}`);
  }

  const data = await res.json();
  // Ensure backend returns: { products: [], currentPage, totalPages, totalRecords, pageSize }
return {
  products: data.products || [],
  currentPage: data.page || 1,
  totalPages: data.total_pages || 1,
  totalRecords: data.total_records || 0,
  pageSize: data.page_size || 50,
};
};